import { groupBy } from 'lodash-es'
import { isNonEmptyArray } from '#app/lib/boolean_tests'
import type { SubEntitiesBrowserSortOption } from '#entities/components/lib/sub_entities_browser_helpers'
import { getAndAssignPopularity } from '#entities/lib/entities'
import type { SerializedEntity } from '#entities/lib/entities'
import type { SerializedItemWithUserData } from '#inventory/lib/items'

const sortingPromises = {
  byPopularity: getAndAssignPopularity,
  byItemsOwnersCount: assignItemsToEditions,
}

interface SortEntitiesParams {
  option: SubEntitiesBrowserSortOption
  entities: SerializedEntity[]
  promise: Promise<SerializedItemWithUserData[]>
}

export async function sortEntities ({ option, entities, promise }: SortEntitiesParams) {
  const { sortFunction, value: sortingName } = option
  if (!sortFunction) return entities
  const sortingPromise = sortingPromises[sortingName]
  // TODO: find a way to not re assign items every time sortEntities is triggered
  if (sortingPromise) await sortingPromise({ entities, promise })
  return entities.sort(sortFunction)
}

export async function assignItemsToEditions ({ entities, promise: waitingForItems }) {
  const editionsItems = await waitingForItems
  const itemsByEditions = groupBy(editionsItems, 'entity')
  entities.forEach(assignItemsToEdition(itemsByEditions))
}

export const assignItemsToEdition = itemsByEditions => edition => {
  if (edition.items) return
  const items = itemsByEditions[edition.uri]
  if (isNonEmptyArray(items)) edition.items = items
}

export async function sortFunctionPlaceholder (entities: SerializedEntity[]) {
  return entities
}
